import { Map } from 'immutable';
import { snakeCase } from 'lodash';
import { ITyped } from '../shared/interfaces/typed.interface';
import { BarChart } from './bar-chart.model';
import { ChartTypesEnum } from './chart-types.enum';
import { SummaryChart } from './summary-chart.model';

export const chartFactory = function (props: Map<string, any>): ITyped {
  const entryType = snakeCase(props.get('type')); // converting dashed-type we get from backend into snake_case so we
  // can compare its value with ChartTypesEnum.
  // e.g. bar-chart -> bar_chart

  switch (entryType) {
    case ChartTypesEnum.bar_chart:
      return new BarChart(props);
    case ChartTypesEnum.summary_chart:
      return new SummaryChart(props);
    default:
      throw new Error(`Unsupported dashboard chart type: ${entryType}.`);
  }
};
